<ng-container *ngIf="listaNotificaciones"></ng-container>
<table mat-table [dataSource]="listaNotificaciones" class="table-striped tableStyle">
  <ng-container *ngFor="let tablecolope of tableColumns">
    <ng-container [matColumnDef]="tablecolope.id">
      <th mat-header-cell *matHeaderCellDef>{{ tablecolope.name }}</th>
      <!--td  mat-cell *matCellDef="let element">{{ element[tablecolope.id] }}</td-->
      <td mat-cell *matCellDef="let element" [ngClass]="{'danger': element[tablecolope.id].includes('DANGER')}">
        <a ></a>
        <p *ngIf="checkColumnaNumerica(tablecolope)">
          {{ element[tablecolope.id] | number : '1.2-2' }}
        </p>
        <p>
          {{ element[tablecolope.id]}}
        </p>
      </td>
    </ng-container>
  </ng-container>

  <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

  <tr mat-header-row *matHeaderRowDef="operacionesColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: operacionesColumns"></tr>
</table>
<mat-paginator [pageSizeOptions]="[100]" [length]="totalRegistros" [pageIndex]="pagina" (page)="cambioDePagina($event)"
  aria-label="Select page of periodic elements">
</mat-paginator>